import * as React from "react";
import type { SVGProps } from "react";

const FacilityMetro = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <ellipse
      cx="10.0013"
      cy="9.85286"
      rx="8.33333"
      ry="8.33333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7462 16.7023L12.8555 13.8662"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14462 13.8662L5.25391 16.7023"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6654 14.1663H8.33203C6.95132 14.1663 5.83203 13.0471 5.83203 11.6663V7.91634C5.83203 6.76575 6.76477 5.83301 7.91536 5.83301H12.082C13.2326 5.83301 14.1654 6.76575 14.1654 7.91634V11.6663C14.1654 13.0471 13.0461 14.1663 11.6654 14.1663Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1654 9.30534H5.83203"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.082 11.2497H11.6654"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.91536 11.2497H8.33203"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityMetro.displayName = "FacilityMetro";

export default FacilityMetro;
